import BoubleText, {
  BubbleType,
} from '../../../../component/bubble-text/bouble-text';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import img from '../../../../assets/icons/notification-icon.svg';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ThreeDots from '../../../../assets/icons/three-dots.svg';
import Expandable from '../../../../component/expandable/expandable';
import DropDownList, {
  DropDownItem,
  ItemType,
} from '../../../../component/ui/drop-down-list/drop-down-list';
import React, { useCallback, useEffect, useState } from 'react';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';
import globalCourseStore from '../../../../stores/global-course-store';
import { CourseMetadataType } from '../../../../api/types/programs/course/course-metadata.type';
import { CourseStatus } from '../../../../api/types/programs/course/course-status';
import { updateCourseStatusOperations } from './operations/update-course-status-operations';
import globalProgramStore from '../../../../stores/program-store';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import RequestHoursDialog from './request-hours-dialog/request-hours-dialog';
import { requestAdditionalHoursOperation } from './operations/request-additional-hours-operation';
import {
  CourseHourChangeRequestWithUsers,
  HourChangeRequestStatusType,
} from '../../../../api/types/programs/course/course-hours-request-change/course-hours-request-change.type';
import CourseHoursHistoryDialog from './course-hours-history-dialog/course-hours-history-dialog';
import { updateCourseHoursRequestStatusOperation } from './operations/update-course-hours-request-status-operation';
import EditCourseHoursRequestDialog from './course-hours-history-dialog/edit-course-hours-request-dialog';
import { updateCourseHoursRequest } from './course-hours-history-dialog/operations/update-course-hours-request';
import { CourseDetailsType } from '../../../../api/types/programs/course/course-details.type';

export interface CourseAboutDatamodel {
  isProfessor: boolean;
}

const CourseAbout: React.FC<CourseAboutDatamodel> = ({ isProfessor }) => {
  const [students, setStudents] = useState<UserSummaryType[]>([]);
  const [courseMetadata, setCourseMetadata] = useState<CourseMetadataType>();
  const [courseDetails, setCourseDetails] = useState<CourseDetailsType>();
  const [courseRequestHoursChangeHistory, setCourseRequestHoursChangeHistory] =
    useState<CourseHourChangeRequestWithUsers[]>();
  const [showRequestHoursDialog, setShowRequestHoursDialog] = useState(false);
  const [requestHoursLoading, setRequestHoursLoading] = useState(false);
  const [showHistoryDialog, setShowHistoryDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [editingRequest, setEditingRequest] =
    useState<CourseHourChangeRequestWithUsers | null>(null);
  useEffect(() => {
    if (
      globalCourseStore.getCurrentCourse() &&
      globalCourseStore.getCurrentCourse()!.details
    ) {
      setCourseMetadata(globalCourseStore.getCurrentCourse()!.metadata);
      setCourseDetails(globalCourseStore.getCurrentCourse()!.details);
      setStudents(globalCourseStore.getCurrentCourse()!.details!.students);
      setCourseRequestHoursChangeHistory(
        globalCourseStore.getCurrentCourse()!.details!.courseHoursRequest,
      );
    }
  }, [globalCourseStore.currentId, globalCourseStore.version]);

  const handleUpdateCourseStatus = async (status: CourseStatus) => {
    const programId = globalProgramStore.getCurrentId();
    if (courseMetadata && status && programId) {
      await updateCourseStatusOperations(
        programId,
        courseMetadata.id,
        courseMetadata.programYear,
        status,
        () => {
          console.log('asd');
          const updatedCourseMetadata = {
            ...courseMetadata,
            status: status,
          };
          setCourseMetadata(updatedCourseMetadata);
        },
      );
    }
  };

  const getCourseStatusBubble = () => {
    if (!courseMetadata) {
      return;
    } else {
      let text: string | null = null;
      let bubbleType: BubbleType | null = null;
      switch (courseMetadata.status) {
        case CourseStatus.INIT:
          text = 'אותחל';
          bubbleType = BubbleType.GREEN;
          return <Tag severity={'info'} value={'אותחל'} />;
          break;

        case CourseStatus.FINISHED:
          return <Tag severity={'success'} value={'הסתיים בהצלחה'} />;
          break;
        case CourseStatus.ACTIVE:
          text = 'פעיל';
          return <Tag severity={'secondary'} value={'פעיל'} />;
          break;
        case CourseStatus.CLOSED:
          return <Tag severity={'danger'} value={'לא פעיל'} />;
          break;
      }
      if (text && bubbleType !== null) {
        return <BoubleText text={text} type={bubbleType} />;
      }
      return;
    }
  };

  const getCourseStatusDropDownListStatus = () => {
    if (!courseMetadata) {
      return;
    }
    const dropDownItem: DropDownItem[] = [];
    switch (courseMetadata.status) {
      case CourseStatus.ACTIVE:
      case CourseStatus.INIT:
        dropDownItem.push({
          itemType: ItemType.TEXT,
          itemText: 'שנה ללא פעיל',
          value: CourseStatus.CLOSED,
        });
        dropDownItem.push({
          itemType: ItemType.TEXT,
          itemText: 'סיים קורס',
          value: CourseStatus.FINISHED,
        });
        break;
      case CourseStatus.FINISHED:
      case CourseStatus.CLOSED:
        dropDownItem.push({
          itemType: ItemType.TEXT,
          itemText: 'שנה לפעיל',
          value: CourseStatus.ACTIVE,
        });
        break;
    }
    return (
      <DropDownList
        onClick={async (index: number, type: DropDownItem) => {
          await handleUpdateCourseStatus(type.value);
        }}
        items={dropDownItem}
      />
    );
  };

  const handleRequestAdditionalHours = async (
    requestedHours: number,
    justification: string,
  ) => {
    const programId = globalProgramStore.getCurrentId();
    if (courseMetadata && programId) {
      await requestAdditionalHoursOperation(
        programId,
        courseMetadata.id,
        requestedHours,
        justification,
        setRequestHoursLoading,
      );
      setShowRequestHoursDialog(false);
    }
  };

  const handleStatusUpdate = async (
    requestId: number,
    status: HourChangeRequestStatusType,
  ) => {
    const programId = globalProgramStore.getCurrentId();
    if (courseMetadata && programId) {
      await updateCourseHoursRequestStatusOperation(
        programId,
        courseMetadata.id,
        requestId,
        status,
        () => {
          //
        }, // No loading state needed as it's handled in the dialog
      );
      // Close dialog and refresh will be handled by re-fetching data
      setShowHistoryDialog(false);
      // Trigger a refresh of the course data
      window.location.reload();
    }
  };

  const handleEditRequest = (request: CourseHourChangeRequestWithUsers) => {
    setEditingRequest(request);
    setShowEditDialog(true);
  };

  const handleSaveEditedRequest = async (
    newHours: number,
    newJustification: string,
  ) => {
    if (!editingRequest || !courseMetadata) {
      return;
    }

    const programId = globalProgramStore.getCurrentId();
    if (!programId) {
      return;
    }

    await updateCourseHoursRequest({
      programId,
      courseId: courseMetadata.id,
      requestId: editingRequest.id,
      newHours,
      newJustification,
      setLoading: () => {
        //
      }, // Loading is handled in the dialog
    });

    // Close dialogs and refresh
    setShowEditDialog(false);
    setEditingRequest(null);
    setShowHistoryDialog(false);
    // Trigger a refresh of the course data
    window.location.reload();
  };

  return (
    <div>
      <div className={'general-course-page-card'}>
        <div
          className={'general-course-page-card-row'}
          style={{ justifyContent: 'space-between' }}
        >
          <div className={'general-course-page-card-title'}>על הקורס</div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {getCourseStatusBubble()}
            {!isProfessor && (
              <Expandable
                makeAbsolute={true}
                displayChevron={false}
                title={'Title'}
                top={
                  <img
                    onClick={() => {
                      // TODO
                    }}
                    height={15}
                    src={ThreeDots}
                  />
                }
                bottom={getCourseStatusDropDownListStatus()}
              ></Expandable>
            )}
          </div>
        </div>

        <div
          className={
            'general-course-page-card-line general-course-page-card-row-height-space'
          }
        ></div>

        {courseMetadata?.courseStartDate && (
          <>
            <div
              className={
                'general-course-page-card-row general-course-page-card-row-height-space'
              }
            >
              <img src={img} />
              <div className={'general-course-page-card-row-text-bold'}>
                תאריך התחלה:{' '}
                {new Date(courseMetadata.courseStartDate).toLocaleDateString(
                  'he-IL',
                )}
              </div>
            </div>

            <div
              className={
                'general-course-page-card-line general-course-page-card-row-height-space'
              }
            ></div>
          </>
        )}

        {courseDetails?.lectures && (
          <>
            <div
              className={
                'general-course-page-card-row general-course-page-card-row-height-space'
              }
            >
              <img src={img} />
              <div className={'general-course-page-card-row-text-bold'}>
                סיכום מפגשים: {courseDetails.lectures.length} מפגשים כולל,{' '}
                {
                  courseDetails.lectures.filter(
                    (lecture) =>
                      lecture.sessions && lecture.sessions.length > 0,
                  ).length
                }{' '}
                בוצעו,{' '}
                {
                  courseDetails.lectures.filter(
                    (lecture) =>
                      !lecture.sessions || lecture.sessions.length === 0,
                  ).length
                }{' '}
                עתידיים
              </div>
            </div>

            <div
              className={
                'general-course-page-card-line general-course-page-card-row-height-space'
              }
            ></div>

            <div
              className={
                'general-course-page-card-row general-course-page-card-row-height-space'
              }
            >
              <img src={img} />
              <div className={'general-course-page-card-row-text-bold'}>
                אחוז מפגשים שבוצעו:{' '}
                {courseDetails.lectures.length > 0
                  ? Math.round(
                      (courseDetails.lectures.filter(
                        (lecture) =>
                          lecture.sessions && lecture.sessions.length > 0,
                      ).length /
                        courseDetails.lectures.length) *
                        100,
                    )
                  : 0}
                %
              </div>
            </div>

            <div
              className={
                'general-course-page-card-line general-course-page-card-row-height-space'
              }
            ></div>

            <div
              className={
                'general-course-page-card-row general-course-page-card-row-height-space'
              }
            >
              <img src={img} />
              <div className={'general-course-page-card-row-text-bold'}>
                אחוז ביצוע מסך שעות:{' '}
                {(() => {
                  const totalPlannedHours = courseDetails.lectures.reduce(
                    (total, lecture) => {
                      if (
                        lecture.schedule?.startTime &&
                        lecture.schedule?.endTime
                      ) {
                        const startTime = new Date(lecture.schedule.startTime);
                        const endTime = new Date(lecture.schedule.endTime);
                        const durationHours =
                          (endTime.getTime() - startTime.getTime()) /
                          (1000 * 60 * 60);
                        return total + durationHours;
                      }
                      return total;
                    },
                    0,
                  );

                  const completedHours = courseDetails.lectures.reduce(
                    (total, lecture) => {
                      if (
                        lecture.sessions &&
                        lecture.sessions.length > 0 &&
                        lecture.schedule?.startTime &&
                        lecture.schedule?.endTime
                      ) {
                        const startTime = new Date(lecture.schedule.startTime);
                        const endTime = new Date(lecture.schedule.endTime);
                        const durationHours =
                          (endTime.getTime() - startTime.getTime()) /
                          (1000 * 60 * 60);
                        return total + durationHours;
                      }
                      return total;
                    },
                    0,
                  );

                  return totalPlannedHours > 0
                    ? Math.round((completedHours / totalPlannedHours) * 100)
                    : 0;
                })()}
                %
              </div>
            </div>

            <div
              className={
                'general-course-page-card-line general-course-page-card-row-height-space'
              }
            ></div>
          </>
        )}

        <div
          className={
            'general-course-page-card-row general-course-page-card-row-height-space'
          }
        >
          <img src={img} />
          <div className={'general-course-page-card-row-text-bold'}>
            {students.length} סטודנטים רשומים
          </div>
        </div>

        {courseMetadata && (
          <div>
            <div
              className={
                'general-course-page-card-line general-course-page-card-row-height-space'
              }
            ></div>

            <div
              className={
                'general-course-page-card-row general-course-page-card-row-height-space'
              }
            >
              <img src={img} />
              <div className={'general-course-page-card-row-text-bold'}>
                {courseMetadata.requiredAttendancePercentage}% נוכחות, מבחן מסכם
                וצבירת {courseMetadata.requiredAssignmentPoints} נק׳, נדרשים
                לסיום קורס זה
              </div>
            </div>

            <div
              className={
                'general-course-page-card-line general-course-page-card-row-height-space'
              }
            ></div>

            <div
              className={
                'general-course-page-card-row general-course-page-card-row-height-space'
              }
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src={img} />
                <div className={'general-course-page-card-row-text-bold'}>
                  {`מכסת שעות בקורס ${courseMetadata.capacityHours}`}
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Tooltip
                  target=".request-hours-btn"
                  content="בקשה לשינוי מכסת שעות בקורס"
                  position="top"
                />
                <Button
                  className="request-hours-btn"
                  icon="pi pi-plus"
                  size="small"
                  visible={!isProfessor}
                  text
                  rounded
                  onClick={() => setShowRequestHoursDialog(true)}
                  style={{
                    width: '24px',
                    height: '24px',
                    fontSize: '12px',
                    color: '#007ad9',
                    marginRight: '4px',
                  }}
                />

                {courseRequestHoursChangeHistory &&
                  courseRequestHoursChangeHistory.length > 0 && (
                    <>
                      <Tooltip
                        target=".history-btn"
                        content="הצג היסטוריית בקשות"
                        position="top"
                      />
                      <Button
                        className="history-btn"
                        icon="pi pi-eye"
                        size="small"
                        text
                        rounded
                        onClick={() => setShowHistoryDialog(true)}
                        style={{
                          width: '24px',
                          height: '24px',
                          fontSize: '12px',
                          color: '#6c757d',
                          position: 'relative',
                        }}
                      />
                      <span
                        style={{
                          backgroundColor: '#007ad9',
                          color: 'white',
                          borderRadius: '10px',
                          padding: '2px 6px',
                          fontSize: '10px',
                          marginLeft: '4px',
                          minWidth: '16px',
                          textAlign: 'center',
                        }}
                      >
                        {courseRequestHoursChangeHistory.length}
                      </span>
                    </>
                  )}
              </div>
            </div>

            <div
              className={
                'general-course-page-card-line general-course-page-card-row-height-space'
              }
            ></div>

            <div
              className={
                'general-course-page-card-row general-course-page-card-row-height-space'
              }
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src={img} />
                <div className={'general-course-page-card-row-text-bold'}>
                  {`שעות ששובצו ${Number(courseMetadata.scheduledHours).toFixed(1)}`}
                </div>
              </div>
            </div>

            <div
              className={
                'general-course-page-card-line general-course-page-card-row-height-space'
              }
            ></div>

            <div
              className={
                'general-course-page-card-row general-course-page-card-row-height-space'
              }
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src={img} />
                <div className={'general-course-page-card-row-text-bold'}>
                  {`שעות שבוצעו ${Number(courseMetadata.hoursActuallyWorked).toFixed(1)}`}
                </div>
              </div>
            </div>

            <div
              className={
                'general-course-page-card-line general-course-page-card-row-height-space'
              }
            ></div>

            <div
              className={
                'general-course-page-card-row general-course-page-card-row-height-space'
              }
            >
              <img src={img} />
              <div className={'general-course-page-card-row-text-bold'}>
                <span style={{ fontWeight: 'bold' }}>ציון ממוצע לקורס:</span>{' '}
                {courseMetadata.averageGrade !== null
                  ? courseMetadata.averageGrade.toFixed(1)
                  : 'טרם הוזנו מספיק ציונים'}
              </div>
            </div>
          </div>
        )}

        <div className={'general-course-page-card-row-height-space'}></div>
      </div>

      <RequestHoursDialog
        visible={showRequestHoursDialog}
        onHide={() => setShowRequestHoursDialog(false)}
        onConfirm={handleRequestAdditionalHours}
        loading={requestHoursLoading}
      />

      <CourseHoursHistoryDialog
        visible={showHistoryDialog}
        onHide={() => setShowHistoryDialog(false)}
        historyData={courseRequestHoursChangeHistory || []}
        onStatusUpdate={handleStatusUpdate}
        onEditRequest={handleEditRequest}
      />

      <EditCourseHoursRequestDialog
        visible={showEditDialog}
        onHide={() => setShowEditDialog(false)}
        request={editingRequest}
        onSave={handleSaveEditedRequest}
      />
    </div>
  );
};

export default CourseAbout;
